import { useCallback } from 'react';
import { alertSrc } from '#shared/assets';
import { useConfirm } from '#shared/lib/hooks';
import { showError, showSuccess } from '#shared/lib/toast';
import { deleteCharacteristicGroups } from '../api';

export function useCharacteristicGroupConfirmDelete() {
    const { confirm, renderConfirmModal } = useConfirm();

    const confirmDelete = useCallback(
        async (groupIds: string[]) => {
            const isConfirmed = await confirm({
                title: `Все характеристики будут перенесены в группу по умолчанию`,
                applyText: 'Подтвердить',
                imageSrc: alertSrc,
                'data-testid': 'CharacteristicGroupConfirmDelete',
            });

            if (!isConfirmed) {
                return;
            }

            try {
                await deleteCharacteristicGroups({ group_ids: groupIds });
                showSuccess('Группа удалена');
            } catch (error) {
                showError({ label: 'Произошла ошибка при удалении' }, error);
            }
        },
        [confirm]
    );

    return { confirmDelete, renderConfirmModal };
}
